/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var LOG = require('logger').getLogger('credit.channel');

var $ = window.jQuery = require('base'), common_header = require('../common/com.jufeng.common.header');

$('#btn-credit-apply').click(function(){
	common_header.context.done(function(context){
		context.try_login(function(){
			window.location.href = "/credit/apply.htm";
		})
	})
})

//======================================
require('../css/bootstrap.css');
require('../css/font/fonts.css');
require('../css/cat_nav.less');
require('../css/style2.css');
require('../css/common.css');
require('../css/header.less');
require('../css/footer.css');
require('../css/layer.css');
require('../css/activity.less');
require('../css/floor_right.less');
require('../css/spec_credit/sl_css.css');




// WEBPACK FOOTER //
// ./src/main/javascript/credit/com.jufeng.credit.channel.js